<div class="animated fadeIn" *ngIf="category">

    <table-component (onEdit)="onEdit($event)"
                     (onAdd)="onAdd()"
                     (onRemove)="onRemove($event)"></table-component>

</div>

<model-notification-emails-edit-component></model-notification-emails-edit-component>
